import { BpOption } from "@models/ui-components/bp-option";

export const WATCHLIST_PILL_VALUE = "watchList";
export const BUY_ORDERS_PILL_VALUE = "buyOrders";
export const SELL_ORDERS_PILL_VALUE = "sellOrders";
export const TOTAL_ORDERS_PILL_VALUE = "totalOrders";
export const CANCELLED_ORDERS_PILL_VALUE = "cancelledOrders";
export const EXECUTED_ORDERS_PILL_VALUE = "executedOrders";

export enum FollowingPillsEnum {
	WATCHLIST = "watchList",
	BUY_ORDERS = "buyOrders",
	SELL_ORDERS = "sellOrders",
	TOTAL_ORDERS = "totalOrders",
	CANCELLED_ORDERS = "cancelledOrders",
	EXECUTED_ORDERS = "executedOrders"
}

export const FOLLOWING_PILL_OPTIONS: BpOption[] = [
	{ label: "watchlist_title", value: WATCHLIST_PILL_VALUE },
	{ label: "buy_orders", value: BUY_ORDERS_PILL_VALUE },
	{ label: "sell_orders", value: SELL_ORDERS_PILL_VALUE },
	{ label: "limit_orders", value: TOTAL_ORDERS_PILL_VALUE }
];
